import { jsx } from 'react/jsx-runtime';

const SvgSymbol = ({ spritePath, symbol, width = 100, height = 100, className, }) => {
    return (jsx("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, style: { width, height, flexShrink: 0 }, className: className, children: jsx("use", { href: `${spritePath}#sym:${symbol}` }) }));
};

export { SvgSymbol };
